import { render, staticRenderFns } from "./help_center.vue?vue&type=template&id=67a1a312&scoped=true&"
import script from "./help_center.vue?vue&type=script&lang=js&"
export * from "./help_center.vue?vue&type=script&lang=js&"
import style0 from "./help_center.vue?vue&type=style&index=0&id=67a1a312&scoped=true&lang=css&"
import style1 from "./help_center.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a1a312",
  null
  
)

export default component.exports